import { coerceBoolean, isDefined, isEmpty } from '@hsp/utilities';

import { routes } from 'routes';
import { IMenuItem } from 'types/menu';
import { Route } from 'types/routes';
import { buildUrl } from 'utilities/strings';

const createMenuItem = (route: Route): IMenuItem => {
  const { children, className, icon, includeInMenu, path, roles, title } = route;
  const include = coerceBoolean(includeInMenu, false);

  let menuItem: Partial<IMenuItem> = {
    className,
    icon,
    includeInMenu: include,
    roles,
    title,
  };

  if (isDefined(path)) {
    menuItem = {
      ...menuItem,
      path: buildUrl(path),
    };
  }

  if (isDefined(children) && !isEmpty(children)) {
    menuItem = {
      ...menuItem,
      children: children.map((child) => createMenuItem(child)),
    };
  }

  return menuItem as IMenuItem;
};

export const buildMenu = () => {
  const { verticalLayout } = routes;
  const menuItems: IMenuItem[] = (verticalLayout?.children ?? []).reduce((current, route) => {
    const menuItem = createMenuItem(route);

    if (isDefined(menuItem)) {
      current = [...current, menuItem];
    }

    return current;
  }, [] as IMenuItem[]);

  return menuItems;
};
